
import {getClasses} from "./database.js"
import { getCurrentDay } from "./getLiveClass.js"
const colors = {
    "MAIN": "#0072CF",
    "A": "#2CBF1B" ,
    "B": "#F5B700",
    "C": "#DC0073",
    "D": "#FE5E41",
    "E": "#623061" ,
    "F": "#DB0030",
    "CLARK": "#0eaec7",
    "WEBSTER": "#15619e",
    "ADV": "#0072CF"
}

const clubColors = {
    "FTC Robotics":"#FF4242"
}


//Master Schedule for 23-24
// const masterSchedule =  [[], [[["8:10", "9:00"], "F", false, colors.F], [["9:05", "9:55"], "Clark 1", false, colors.CLARK], [["10:00", "10:50"], "A", false, colors.A], [["10:50", "11:30"], "MX", true, colors.MAIN], [["11:30", "11:50"], "Advisory", true, colors.MAIN], [["11:55", "12:45"], "E", false, colors.E], [["12:50", "13:20"], "Lunch", true, colors.MAIN], [["13:25", "14:15"], "C", false, colors.C], [["14:20", "15:10"], "B", false, colors.B], [["15:15", "16:05"], "Webster 1", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "Clark 2", false, colors.CLARK], [["9:00", "9:50"], "D", false, colors.D], [["9:55", "10:45"], "F", false, colors.F], [["10:50", "11:35"], "A Sci", false, colors.A, {backup:["Conference", true, colors.MAIN]}], [["11:40", "12:25"], "Webster 2", false, colors.WEBSTER], [["12:30", "13:00"], "Lunch", true, colors.MAIN], [["13:05", "13:55"], "B", false, colors.B], [["14:00", "14:50"], "E", false, colors.E] ,[["14:55", "15:45"], "C Sci", false, colors.CLARK, {backup:["Conference", true, colors.MAIN]}]],
//    [[["8:10", "9:00"], "Clark 3", false, colors.CLARK], [["9:05", "9:55"], "C", false, colors.C], [["10:00", "10:50"], "A", false, colors.A], [["10:50", "11:30"], "Graderoom", true, colors.MAIN], [["11:35", "12:25"], "B", false, colors.B], [["12:30", "13:00"], "Lunch", true, colors.MAIN], [["13:05", "13:55"], "F", false, colors.F], [["14:00", "14:50"], "D", false, colors.D], [["14:55", "15:45"], "Webster 3", false, colors.WEBSTER], [["15:40", "16:25"], "GJ", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "Clark 4", false, colors.CLARK], [["9:05", "9:55"], "F", false, colors.F], [["10:00", "10:50"], "C", false, colors.C], [["10:55", "11:45"], "B Sci", false, colors.B, {backup:["Conference", true, colors.MAIN]}], [["11:50", "12:20"], "Lunch", true, colors.MAIN], [["12:25", "13:15"], "D", false, colors.D], [["13:20", "14:10"], "E", false, colors.E], [["14:15", "15:05"], "A", false, colors.A], [["15:10", "16:00"], "Webster 4", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "B", false, colors.B], [["9:05", "9:55"], "A", false, colors.A], [["10:00", "10:50"], "E", false, colors.E], [["10:50", "11:30"], "MX", true, colors.MAIN], [["11:30", "11:50"], "Advisory", true, colors.MAIN], [["11:55", "12:45"], "D", false, colors.D], [["12:50", "13:20"], "Lunch", true, colors.MAIN], [["13:25", "14:05"], "SG", true, colors.MAIN], [["14:10", "15:00"], "C", false, colors.C], [["15:05", "15:55"], "Webster 5", false, colors.WEBSTER],[["15:55", "16:25"], "GJ", false, colors.WEBSTER]], []]

   //Master Schedule for 23-24
// const masterSchedule =  [[], [[["8:10", "9:00"], "C", false, colors.F], [["9:05", "9:55"], "Clark 1", false, colors.CLARK], [["10:00", "10:50"], "B", false, colors.A], [["10:50", "11:30"], "MX", true, colors.MAIN], [["11:30", "11:50"], "Advisory", true, colors.MAIN], [["11:55", "12:45"], "A", false, colors.E], [["12:50", "13:20"], "Lunch", true, colors.MAIN], [["13:30", "14:15"], "F", false, colors.C], [["14:20", "15:10"], "C", false, colors.B], [["15:15", "16:05"], "Webster 1", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "Clark 2", false, colors.CLARK], [["9:00", "9:50"], "D", false, colors.D], [["9:55", "10:45"], "F", false, colors.F], [["10:50", "11:35"], "A Sci", false, colors.A, {backup:["Conference", true, colors.MAIN]}], [["11:40", "12:25"], "Webster 2", false, colors.WEBSTER], [["12:30", "13:00"], "Lunch", true, colors.MAIN], [["13:05", "13:55"], "B", false, colors.B], [["14:00", "14:50"], "E", false, colors.E] ,[["14:55", "15:45"], "C Sci", false, colors.CLARK, {backup:["Conference", true, colors.MAIN]}]],
//    [[["8:10", "9:00"], "Clark 3", false, colors.CLARK], [["9:05", "9:55"], "C", false, colors.C], [["10:00", "10:50"], "A", false, colors.A], [["10:50", "11:30"], "Graderoom", true, colors.MAIN], [["11:35", "12:25"], "B", false, colors.B], [["12:30", "13:00"], "Lunch", true, colors.MAIN], [["13:05", "13:55"], "F", false, colors.F], [["14:00", "14:50"], "D", false, colors.D], [["14:55", "15:45"], "Webster 3", false, colors.WEBSTER], [["15:40", "16:25"], "GJ", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "Clark 4", false, colors.CLARK], [["9:05", "9:55"], "F", false, colors.F], [["10:00", "10:50"], "C", false, colors.C], [["10:55", "11:45"], "B Sci", false, colors.B, {backup:["Conference", true, colors.MAIN]}], [["11:50", "12:20"], "Lunch", true, colors.MAIN], [["12:25", "13:15"], "D", false, colors.D], [["13:20", "14:10"], "E", false, colors.E], [["14:15", "15:05"], "A", false, colors.A], [["15:10", "16:00"], "Webster 4", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "B", false, colors.B], [["9:05", "9:55"], "A", false, colors.A], [["10:00", "10:50"], "E", false, colors.E], [["10:50", "11:30"], "MX", true, colors.MAIN], [["11:30", "11:50"], "Advisory", true, colors.MAIN], [["11:55", "12:45"], "D", false, colors.D], [["12:50", "13:20"], "Lunch", true, colors.MAIN], [["13:25", "14:05"], "SG", true, colors.MAIN], [["14:10", "15:00"], "C", false, colors.C], [["15:05", "15:55"], "Webster 5", false, colors.WEBSTER],[["15:55", "16:25"], "GJ", false, colors.WEBSTER]], []]


// const masterSchedule = 
// [[[["8:00", "8:45"], "ARTS 1", false, colors.WEBSTER], [["8:45", "10:00"], "B", false, colors.B], [["10:00", "11:00"], "A", false, colors.A], [["11:00", "11:40"], "Clubs", true, colors.MAIN], [["11:40", "12:00"], "Conference", true, colors.MAIN], [["12:00", "13:00"], "C", false, colors.C],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "D", false, colors.D], [["14:30", "15:30"], "Wellness 10", false, colors.WEBSTER]],
// [[["8:00", "8:45"], "ARTS 2", false, colors.WEBSTER], [["8:45", "10:00"], "C", false, colors.C], [["10:00", "11:00"], "E", false, colors.E], [["11:00", "11:40"], "Civic Lab", true, colors.MAIN], [["11:40", "12:00"], "Conference", true, colors.MAIN], [["12:00", "13:00"], "A", false, colors.A],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "B", false, colors.B], [["14:30", "15:30"], "F", false, colors.F]],
// [[["8:00", "8:45"], "ARTS 3", false, colors.WEBSTER], [["8:45", "10:00"], "D", false, colors.D], [["10:00", "11:00"], "C", false, colors.C], [["11:00", "11:40"], "MX", true, colors.MAIN], [["11:40", "12:00"], "Advsiory (All)", true, colors.MAIN], [["12:00", "13:00"], "Wellness 12", false, colors.WEBSTER],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "E", false, colors.E], [["14:30", "15:30"], "B", false, colors.B]],
// [[["8:00", "8:45"], "ARTS 4", false, colors.WEBSTER], [["8:45", "10:00"], "E", false, colors.E], [["10:00", "11:00"], "D", false, colors.D], [["11:00", "11:40"], "SG", true, colors.MAIN], [["11:40", "12:00"], "Advisory (1:1)", true, colors.MAIN], [["12:00", "13:00"], "F", false, colors.F],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "C", false, colors.C], [["14:30", "15:30"], "A", false, colors.A]],
// [[["8:00", "8:45"], "ARTS 5", false, colors.WEBSTER], [["8:45", "10:00"], "A", false, colors.A], [["10:00", "11:00"], "F", false, colors.F], [["11:00", "11:40"], "Clubs", true, colors.MAIN], [["11:40", "12:00"], "Conference", true, colors.MAIN], [["12:00", "13:00"], "E", false, colors.E],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "B", false, colors.B], [["14:30", "15:30"], "Wellness 11", false, colors.WEBSTER]],
// [[["8:00", "8:45"], "ARTS 6", false, colors.WEBSTER], [["8:45", "10:00"], "E", false, colors.E], [["10:00", "11:00"], "C", false, colors.C], [["11:00", "11:40"], "Graderoom", true, colors.MAIN], [["11:40", "12:00"], "Conference", true, colors.MAIN], [["12:00", "13:00"], "B", false, colors.B],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "F", false, colors.F], [["14:30", "15:30"], "D", false, colors.D]],
// [[["8:00", "8:45"], "ARTS 7", false, colors.WEBSTER], [["8:45", "10:00"], "F", false, colors.F], [["10:00", "11:00"], "D", false, colors.D], [["11:00", "11:40"], "MX", true, colors.MAIN], [["11:40", "12:00"], "Advisory (All)", true, colors.MAIN], [["12:00", "13:00"], "Wellness 9", false, colors.WEBSTER],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "A", false, colors.A], [["14:30", "15:30"], "C", false, colors.C]],
// [[["8:00", "8:45"], "ARTS 8", false, colors.WEBSTER], [["8:45", "10:00"], "A", false, colors.A], [["10:00", "11:00"], "B", false, colors.B], [["11:00", "11:40"], "SG", true, colors.MAIN], [["11:40", "12:00"], "Advisory (1:1)", true, colors.MAIN], [["12:00", "13:00"], "D", false, colors.D],[["13:00", "13:30"], "Lunch", true, colors.MAIN], [["13:30", "14:30"], "F", false, colors.F], [["14:30", "15:30"], "E", false, colors.E]],
// ]

export const masterSchedule = 
[[[["8:00", "8:45"], "ARTS 1", false, colors.WEBSTER], [["8:45", "10:00"], "A", false, colors.A], [["10:00", "10:45"], "Clubs", true, colors.MAIN], [["10:45", "11:45"], "D", false, colors.D], [["11:45", "12:45"], "E", false, colors.E], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Conference", true, colors.MAIN], [["13:30", "14:30"], "F", false, colors.F], [["14:30", "15:30"], "Wellness 12", false, colors.WEBSTER]],
[[["8:00", "8:45"], "ARTS 2", false, colors.WEBSTER], [["8:45", "10:00"], "B", false, colors.B], [["10:00", "10:45"], "Graderoom", true, colors.MAIN], [["10:45", "11:45"], "A", false, colors.D],  [["11:45", "12:45"], "C", false, colors.C], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Conference", true, colors.MAIN], [["13:30", "14:30"], "D", false, colors.D], [["14:30", "15:30"], "F", false, colors.F]],
[[["8:00", "8:45"], "ARTS 3", false, colors.WEBSTER], [["8:45", "10:00"], "C", false, colors.C], [["10:00", "10:45"], "MX", true, colors.MAIN], [["10:45", "11:45"], "E", false, colors.E], [["11:45", "12:45"], "Wellness 11", false, colors.WEBSTER], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Advisory (All)", true, colors.ADV], [["13:30", "14:30"], "B", false, colors.B], [["14:30", "15:30"], "A", false, colors.A]],
[[["8:00", "9:00"], "ARTS 4", false, colors.WEBSTER], [["9:00", "10:00"], "C", false, colors.C], [["10:00", "10:45"], "SG", true, colors.MAIN], [["10:45", "11:45"], "F", false, colors.F], [["11:45", "12:45"], "D", false, colors.D], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Advisory (1:1)", true, colors.ADV], [["13:30", "14:30"], "E", false, colors.E], [["14:30", "15:30"], "B", false, colors.B]],
[[["8:00", "8:45"], "ARTS 5", false, colors.WEBSTER], [["8:45", "10:00"], "D", false, colors.D], [["10:00", "10:45"], "Clubs", true, colors.MAIN], [["10:45", "11:45"], "A", false, colors.A], [["11:45", "12:45"], "B", false, colors.B], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Conference", true, colors.MAIN], [["13:30", "14:30"], "C", false, colors.C], [["14:30", "15:30"], "Wellness 10", false, colors.WEBSTER]],
[[["8:00", "8:45"], "ARTS 6", false, colors.WEBSTER], [["8:45", "10:00"], "E", false, colors.E], [["10:00", "10:45"], "Civic Lab", true, colors.MAIN], [["10:45", "11:45"], "D", false, colors.D], [["11:45", "12:45"], "F", false, colors.F], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Conference", true, colors.MAIN], [["13:30", "14:30"], "A", false, colors.A], [["14:30", "15:30"], "C", false, colors.C]],
[[["8:00", "8:45"], "ARTS 7", false, colors.WEBSTER], [["8:45", "10:00"], "F", false, colors.F], [["10:00", "10:45"], "MX", true, colors.MAIN], [["10:45", "11:45"], "B", false, colors.B], [["11:45", "12:45"], "Wellness 9", false, colors.WEBSTER], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Advisory (All)", true, colors.ADV], [["13:30", "14:30"], "E", false, colors.E], [["14:30", "15:30"], "D", false, colors.D]],
[[["8:00", "9:00"], "ARTS 8", false, colors.WEBSTER], [["9:00", "10:00"], "F", false, colors.F], [["10:00", "10:45"], "SG", true, colors.MAIN], [["10:45", "11:45"], "C", false, colors.C], [["11:45", "12:45"], "A", false, colors.A], [["12:45", "13:15"], "Lunch", true, colors.MAIN],[["13:15", "13:30"], "Advisory (1:1)", true, colors.ADV], [["13:30", "14:30"], "B", false, colors.B], [["14:30", "15:30"], "E", false, colors.E]],
]

const specialDays = {[new Date("9/1/25").getTime()]: [[["8:00", "16:00"], "Labor Day", true, "url(https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg) center/cover"]],
[new Date("9/2/25").getTime()]: [[["8:00", "9:00"], "Welcome", true, colors.MAIN], [["9:00", "10:00"], "Advisory", true, colors.ADV], [["10:00", "10:30"], "ARTS", true, colors.WEBSTER], [["10:30", "11:00"], "A", false, colors.A], [["11:00", "11:30"], "B", false, colors.B], [["11:30", "12:00"], "C", false, colors.C], [["12:00", "12:45"], "Community Time (Auditorium)", true, colors.MAIN], [["12:45", "13:15"], "Lunch", true, colors.MAIN], [["13:15", "13:45"], "D", false, colors.D], [["13:45", "14:15"], "E", false, colors.E], [["14:15", "14:45"], "F", false, colors.F], [["14:45", "15:15"], "Wellness (Big Gym)", true, colors.MAIN], [["15:15", "15:30"], "Social Gathering (Courtyard)", true, colors.WEBSTER]],
[new Date("10/9/24").getTime()]: [[["9:00", "13:00"], "Civic Lab", true, colors.MAIN], [["13:00", "13:30"], "C", false, colors.C], [["13:30", "14:00"], "E", false, colors.E],  [["14:00", "14:30"], "A", false, colors.A],[["14:30", "15:00"], "B Flex", false, colors.B], [["15:00", "15:30"], "F", false, colors.F]],
[new Date("11/18/24").getTime()]: [[["9:00", "13:00"], "Civic Lab", true, colors.MAIN], [["13:00", "13:30"], "E Flex", false, colors.E], [["13:30", "14:00"], "D", false, colors.D],  [["14:00", "14:30"], "F", false, colors.F],[["14:30", "15:00"], "C", false, colors.C], [["15:00", "15:30"], "A", false, colors.A]],
[new Date("1/21/25").getTime()]: [[["8:00", "13:00"], "Civic Lab", true, colors.MAIN], [["13:00", "13:30"], "Advisory", true, colors.ADV],[["13:30", "14:30"], "S1 Recap", true, colors.MAIN],  [["14:30", "15:30"], "Student-Led Workshop", true, colors.MAIN]],
[new Date("3/13/25").getTime()]: [[["9:00", "13:00"], "Civic Lab", true, colors.MAIN], [["13:00", "13:30"], "A Flex", false, colors.A], [["13:30", "14:00"], "B", false, colors.B],  [["14:00", "14:30"], "D", false, colors.D], [["14:30", "15:00"], "F", false, colors.F], [["15:00", "15:30"], "E", false, colors.E]],
[new Date("5/2/25").getTime()]: [[["9:00", "13:00"], "Civic Lab", true, colors.MAIN], [["13:00", "13:30"], "E", false, colors.E], [["13:30", "14:00"], "C", false, colors.C],  [["14:00", "14:30"], "B", false, colors.B],[["14:30", "15:00"], "F Flex", false, colors.F], [["15:00", "15:30"], "D", false, colors.D]]
}
//Finals Week S1:
// const masterSchedule =  [[], [],
//    [[["9:00", "11:00"], "A", false, colors.A], [["11:00", "13:00"], "Lunch", true, colors.MAIN], [["13:00", "15:00"], "B", false, colors.B]],
//    [[["9:00", "11:00"], "C", false, colors.C], [["11:00", "13:00"], "Lunch", true, colors.MAIN], [["13:00", "15:00"], "D", false, colors.D]],
//    [[["9:00", "11:00"], "E", false, colors.E], [["11:00", "13:00"], "Lunch", true, colors.MAIN], [["13:00", "15:00"], "F", false, colors.F]],
//   [], []]

//Starting Week 23-24
// const masterSchedule =  [[], [[["8:10", "16:00"], "Labor Day", true, "url(https://upload.wikimedia.org/wikipedia/en/a/a4/Flag_of_the_United_States.svg) center/cover"]],
//    [[["8:10", "8:45"], "Welcome Speeches", true, colors.MAIN], [["8:45", "9:15"], "Faculty Introductions", true, colors.MAIN], [["9:15", "10:00"], "Advisory", true, colors.ADV], [["10:00", "11:00"], "Lawyer", true, colors.MAIN], [["11:15", "11:25"], "A", false, colors.A], [["11:30", "11:40"], "B", false, colors.B], [["11:45", "11:55"], "C", false, colors.C], [["12:00", "12:10"], "D", false, colors.D],[["12:15", "12:25"], "E", false, colors.E], [["12:30", "12:40"], "F", false, colors.F], [["12:45", "13:15"], "Lunch", true, colors.MAIN], [["13:15", "13:25"], "Band", true, colors.CLARK], [["13:30", "13:40"], "Choir", true, colors.CLARK],[["13:45", "13:55"], "PE", true, colors.CLARK], [["14:00", "14:10"], "Dance", true, colors.CLARK], [["14:15", "14:25"], "Stagecraft & DEIB", true, colors.CLARK], [["14:30", "15:30"], "Graderoom", true, colors.MAIN]], 
//    [[["8:10", "9:00"], "Clark 3", false, colors.CLARK], [["9:05", "9:55"], "C", false, colors.C], [["10:00", "10:50"], "A", false, colors.A], [["10:50", "11:30"], "Graderoom", true, colors.MAIN], [["11:35", "12:25"], "B", false, colors.B], [["12:30", "13:00"], "Lunch", true, colors.MAIN], [["13:05", "13:55"], "F", false, colors.F], [["14:00", "14:50"], "D", false, colors.D], [["14:55", "15:45"], "Webster 3", false, colors.WEBSTER], [["15:40", "16:25"], "GJ", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "Clark 4", false, colors.CLARK], [["9:05", "9:55"], "F", false, colors.F], [["10:00", "10:50"], "C", false, colors.C], [["10:55", "11:45"], "B Sci", false, colors.B, {backup:["Conference", true, colors.MAIN]}], [["11:50", "12:20"], "Lunch", true, colors.MAIN], [["12:25", "13:15"], "D", false, colors.D], [["13:20", "14:10"], "E", false, colors.E], [["14:15", "15:05"], "A", false, colors.A], [["15:10", "16:00"], "Webster 4", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "B", false, colors.B], [["9:05", "9:55"], "A", false, colors.A], [["10:00", "10:50"], "E", false, colors.E], [["10:50", "11:30"], "MX", true, colors.MAIN], [["11:30", "11:50"], "Advisory", true, colors.MAIN], [["11:55", "12:45"], "D", false, colors.D], [["12:50", "13:20"], "Lunch", true, colors.MAIN], [["13:25", "14:05"], "SG", true, colors.MAIN], [["14:10", "15:00"], "C", false, colors.C], [["15:05", "15:55"], "Webster 5", false, colors.WEBSTER],[["15:55", "16:25"], "GJ", false, colors.WEBSTER]], []]

//Re Orientation Week 23-24
// const masterSchedule =  [[], [[["9:00", "10:00"], "S1 Recap", true, colors.MAIN], [["10:00", "10:30"], "Advsiory", true, colors.MAIN], [["10:30", "12:00"], "Dialogue Acrosss Difference", true, colors.MAIN], [["12:00", "13:00"], "Lunch", true, colors.MAIN], [["13:00", "14:00"], "Graderoom", true, colors.MAIN], [["14:00", "14:30"], "Hot Cocoa", true, colors.MAIN], [["14:30", "15:00"], "Student Leaders", true, colors.MAIN]],
//    [[["8:10", "9:00"], "Clark 2", false, colors.CLARK], [["9:00", "9:50"], "D", false, colors.D], [["9:55", "10:45"], "F", false, colors.F], [["10:50", "11:35"], "A Sci", false, colors.A, {backup:["Conference", true, colors.MAIN]}], [["11:40", "12:25"], "Webster 2", false, colors.WEBSTER], [["12:30", "13:00"], "Lunch", true, colors.MAIN], [["13:05", "13:55"], "B", false, colors.B], [["14:00", "14:50"], "E", false, colors.E] ,[["14:55", "15:45"], "C Sci", false, colors.CLARK, {backup:["Conference", true, colors.MAIN]}]],
//    [[["8:10", "9:00"], "Clark 3", false, colors.CLARK], [["9:05", "9:55"], "C", false, colors.C], [["10:00", "10:50"], "A", false, colors.A], [["10:50", "11:30"], "Graderoom", true, colors.MAIN], [["11:35", "12:25"], "B", false, colors.B], [["12:30", "13:00"], "Lunch", true, colors.MAIN], [["13:05", "13:55"], "F", false, colors.F], [["14:00", "14:50"], "D", false, colors.D], [["14:55", "15:45"], "Webster 3", false, colors.WEBSTER], [["15:40", "16:25"], "GJ", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "Clark 4", false, colors.CLARK], [["9:05", "9:55"], "F", false, colors.F], [["10:00", "10:50"], "C", false, colors.C], [["10:55", "11:45"], "B Sci", false, colors.B, {backup:["Conference", true, colors.MAIN]}], [["11:50", "12:20"], "Lunch", true, colors.MAIN], [["12:25", "13:15"], "D", false, colors.D], [["13:20", "14:10"], "E", false, colors.E], [["14:15", "15:05"], "A", false, colors.A], [["15:10", "16:00"], "Webster 4", false, colors.WEBSTER]],
//    [[["8:10", "9:00"], "B", false, colors.B], [["9:05", "9:55"], "A", false, colors.A], [["10:00", "10:50"], "E", false, colors.E], [["10:50", "11:30"], "MX", true, colors.MAIN], [["11:30", "11:50"], "Advisory", true, colors.MAIN], [["11:55", "12:45"], "D", false, colors.D], [["12:50", "13:20"], "Lunch", true, colors.MAIN], [["13:25", "14:05"], "SG", true, colors.MAIN], [["14:10", "15:00"], "C", false, colors.C], [["15:05", "15:55"], "Webster 5", false, colors.WEBSTER],[["15:55", "16:25"], "GJ", false, colors.WEBSTER]], []]


   function timeString(time) {
    var currentDate = new Date()
  
    var startDate = new Date(currentDate.getTime());
    startDate.setHours(time[0].split(":")[0]);
    startDate.setMinutes(time[0].split(":")[1]);
  
    var endDate = new Date(currentDate.getTime());
    endDate.setHours(time[1].split(":")[0]);
    endDate.setMinutes(time[1].split(":")[1]);
  
    return startDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).split(" ")[0] + "-"+ endDate.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }).split(" ")[0]
  
  }



function addCustomBlock(user, day, newBlock, looped=false) {
    console.log(JSON.stringify(newBlock))
    var newBlockStart = new Date();
    newBlockStart.setHours(newBlock.time[0].split(":")[0]);
    newBlockStart.setMinutes(newBlock.time[0].split(":")[1]);
    var newBlockEnd = new Date();
    newBlockEnd.setHours(newBlock.time[1].split(":")[0]);
    newBlockEnd.setMinutes(newBlock.time[1].split(":")[1]);
    
    day.every((block, i) => {
        var blockStart = new Date();
        blockStart.setHours(block.time[0].split(":")[0]);
        blockStart.setMinutes(block.time[0].split(":")[1]);
        var blockEnd = new Date();
        blockEnd.setHours(block.time[1].split(":")[0]);
        blockEnd.setMinutes(block.time[1].split(":")[1]);

        if (i === day.length - 1) {
            day.push(newBlock)
            return false;
        } else if (newBlockStart.getTime() > blockStart.getTime()) {
            return true;
        }
         else {
        //    console.log("checpoint2", JSON.stringify(newBlock))
            if(i > 0) {
            var lastBlockEnd = new Date(newBlockStart.getTime());
            lastBlockEnd.setHours(day[i-1].time[1].split(":")[0]);
            lastBlockEnd.setMinutes(day[i-1].time[1].split(":")[1]);
            if (lastBlockEnd.getTime() > newBlockStart.getTime()) {
                day[i-1].time[1] = newBlockStart.getHours()+":"+newBlockStart.getMinutes()
            }
        }
        if (blockStart.getTime() < newBlockEnd.getTime()) {
        //    console.log("checkpoint3", JSON.stringify(newBlock))
            var skipped = false;
            for (var b = i; b < day.length; b++) {
          //      console.log("checkpoint3.5", JSON.stringify(newBlock))
                var bStart = new Date(newBlockStart.getTime());
                bStart.setHours(day[b].time[0].split(":")[0]);
                bStart.setMinutes(day[b].time[0].split(":")[1]);
                var bEnd = new Date(newBlockStart.getTime());
                bEnd.setHours(day[b].time[1].split(":")[0]);
                bEnd.setMinutes(day[b].time[1].split(":")[1]);
                if (bEnd.getTime() <= newBlockEnd.getTime()) {
                    if (user.settings.coverride || (day[b].isMain && !skipped)) {
                    day.splice(b, 1)
                    b--;
                    } else if (day[b].isMain && skipped) {
                        skipped = false;
                        var nB = JSON.parse(JSON.stringify(newBlock))
                        nB.time[0] = day[b].time[0]
                        nB.time[1] = newBlockEnd.getHours()+":"+newBlockEnd.getMinutes()
                        day = addCustomBlock(user, day, nB, true);
                        break;
                        //day[b].name = newBlock.name
                        //day[b].color = newBlock.color
                    } else {
                        
                        newBlock.time[1] = day[i].time[0]
                       // console.log("checkpoint4", JSON.stringify(newBlock))
                        skipped = true;
                       // break;
                    }
                } else {
                   
                    // if ((user.settings.coverride || day[b].isMain)) {
                    // //    console.log("override", newBlock)
                    //     var nB = JSON.parse(JSON.stringify(newBlock))
                    //     nB.time[0] = day[b].time[0]
                    //     nB.time[1] = newBlockEnd.getHours()+":"+newBlockEnd.getMinutes()
                    //     day.splice(b, 0, nB)
                    //     b++;
                    // } 
                    if (user.settings.coverride || day[b].isMain) {
                    day[b].time[0] = newBlockEnd.getHours()+":"+newBlockEnd.getMinutes()
                    } else {
                       
                       // newBlock.time[1] = blockStart.getHours()+":"+blockStart.getMinutes()
                        //console.log("checkpoint3.75", JSON.stringify(newBlock))
                    }
                    
                    break;
                }
            }
        
        } else {
            
            newBlock.time[1] = blockStart.getHours()+":"+blockStart.getMinutes()
            
        }

        }
        console.log("checkpoint5", JSON.stringify(newBlock))
            
            day.splice(i, 0, newBlock)
            return false;
        })
    return day;
}

function generateSchedule(user, clubs) {
    console.log("checkpoint1", user)
    return new Promise((resolve, reject) => {
    var schedule = []
    var weekMode = user.settings && !user.settings.fcycle;
    if (!user.settings.hasOwnProperty("local")) {
    getClasses().then((globalClasses) => {
        
        if (weekMode) {
            resolve(processWeekModeSchedule(user, clubs, globalClasses))
        } else {
        resolve(processFullSchedule(user, clubs, globalClasses))
    }})
    
} else {
    if (weekMode) {
        resolve(processWeekModeSchedule(user, clubs))
    } else {
    resolve(processFullSchedule(user, clubs))
}

}
    })
}

function processFullSchedule(user, clubs, globalClasses=null) {
    var schedule = []
    var currentDate = new Date(Math.max(new Date().getTime(), new Date("9/1/2026").getTime()))

            while (getCurrentDay(currentDate) !== 0) {
                currentDate.setDate(currentDate.getDate()-1)
            }


            while (schedule.length < masterSchedule.length) {
            var currentDay = getCurrentDay(currentDate)
            if (currentDay != -1 && currentDate.getDay() != 0 && currentDate.getDay() != 6) {
            var daySchedule = {schedule:processDay(masterSchedule[currentDay], user, globalClasses), date:new Date(currentDate.getTime()), day:currentDay}
            
           
            schedule.push(daySchedule)
            
        }
        currentDate.setDate(currentDate.getDate()+1)
           console.log(schedule.length)
            }
            if (user.settings.hasOwnProperty("clubs") && user.settings.clubs) {
                Object.entries(clubs).forEach(([k, club]) => {
                    
                    if (user.settings.clubs.hasOwnProperty(k) && user.settings.clubs[k]) {
                        if (club.hasOwnProperty("meetings")) {
                    Object.values(club.meetings).forEach((meeting) => {
                        var day;
                        var newBlock;
                        if (meeting.type === "weekly") {
                            schedule.forEach(day => {
                                if (day.date.getDay()-1 == meeting.day) {
                                    console.log("YAAAAAAAAAA")
                                    newBlock = {
                                        name: k,
                                        color: club.color,
                                        time:[meeting.time.start, meeting.time.end],
                                        period: "Meets Weekly",
                                        isMain: false
                                    }
                                    day.schedule = addCustomBlock(user, day.schedule, newBlock);
                                }
                            });
                            
                        } else if (meeting.type === "cyclic") {
                            day = schedule[meeting.day]
                            newBlock = {
                                name: k,
                                color: club.color,
                                time:[meeting.time.start, meeting.time.end],
                                period: "Meets Cyclically",
                                isMain: false
                            }
                            day.schedule = addCustomBlock(user, day.schedule, newBlock);
                            
                            
                        }else if (meeting.type === "one-time") {
                            schedule.forEach(day => {
                                if (day.date.getTime() === new Date(meeting.day + " CDT").getTime()) {
                                    newBlock = {
                                        name: k,
                                        color: club.color,
                                        time:[meeting.time.start, meeting.time.end],
                                        period: "One Time Meeting",
                                        isMain: false
                                    }
                                    day.schedule = addCustomBlock(user, day.schedule, newBlock);
                                }
                            })
                        }
                    
                        })
                    }
                    }
                    })
                }
                return schedule;
}

function processWeekModeSchedule(user, clubs, globalClasses=null) {
    var schedule = []
    var monday = new Date(Math.max(new Date().getTime(), new Date("9/1/2026").getTime()))
    monday.setHours(0,0,0,0)
            monday.setDate(monday.getDate() - monday.getDay() + 1);
            if (new Date().getDay() === 6 ) monday.setDate(monday.getDate() + 7)
            
            for (var i = 0; i < 5; i++) {
                
                var currentDay = getCurrentDay(monday);
                var daySchedule = {schedule:[], date:new Date(monday.getTime()), day:currentDay}
                if (currentDay > -1) {
               //     console.log("SDAYS", specialDays, monday)
                    if (specialDays.hasOwnProperty(monday.getTime())) {
                        var specialDay = specialDays[monday.getTime()]
                        console.log("Special Day", specialDay)
                        daySchedule.schedule = processDay(specialDay, user, globalClasses)
                    } else {
                var day = masterSchedule[(currentDay)]
                daySchedule.schedule = processDay(day, user, globalClasses)
                    }
                
                } else if (specialDays.hasOwnProperty(monday.getTime())) {
                    daySchedule.schedule = processDay(specialDays[monday.getTime()], user, globalClasses)
                

        } else {
            console.log("No School", specialDays, monday)
            daySchedule.schedule.push({name: "No School", color: "gray", time: ["8:00", "16:00"], isMain: true})
        }
            schedule.push(daySchedule)
            monday.setDate(monday.getDate() + 1)
            }

            if (user.settings.hasOwnProperty("clubs") && user.settings.clubs) {
                Object.entries(clubs).forEach(([k, club]) => {
                    
                    if (user.settings.clubs.hasOwnProperty(k) && user.settings.clubs[k]) {
                        if (club.hasOwnProperty("meetings")) {
                    Object.values(club.meetings).forEach((meeting) => {
                        var day;
                        var newBlock;
                        if (meeting.type === "weekly") {
                            day = schedule[meeting.day]
                            newBlock = {
                                name: k,
                                color: club.color,
                                time:[meeting.time.start, meeting.time.end],
                                period: "Meets Weekly",
                                isMain: false
                            }
                            schedule[meeting.day].schedule = addCustomBlock(user, day.schedule, newBlock);
                        } else if (meeting.type === "cyclic") {
                            schedule.forEach(day => {
                                if (day.day === meeting.day) {
                                    newBlock = {
                                        name: k,
                                        color: club.color,
                                        time:[meeting.time.start, meeting.time.end],
                                        period: "Meets Cyclically",
                                        isMain: false
                                    }
                                    day.schedule = addCustomBlock(user, day.schedule, newBlock);
                                }
                            });
                        } else if (meeting.type === "one-time") {
                            schedule.forEach(day => {
                                if (day.date.getTime() === new Date(meeting.day + " CDT").getTime()) {
                                    newBlock = {
                                        name: k,
                                        color: club.color,
                                        time:[meeting.time.start, meeting.time.end],
                                        period: "One Time Meeting",
                                        isMain: false
                                    }
                                    day.schedule = addCustomBlock(user, day.schedule, newBlock);
                                }
                            })
                        }
                            
    
                            
                        })
                    }
                }
                    })
                }
            return schedule;
}



function processDay(day, user, globalClasses=null) {

    var daySchedule = []
    day.forEach(function (block) {
        var isFlex = false;
        //&& user.classes.hasOwnProperty(block[1].split(" ")[0]) && user.classes[block[1].split(" ")[0]].hasOwnProperty("params") && user.classes[block[1].split(" ")[0]].params.hasOwnProperty("flex")
            if (block[1].includes("Flex") ) {
                block[1] = block[1].split(" ")[0]
                isFlex = true;
            }
            if (user.classes.hasOwnProperty(block[1]) ) {
                var color;
                if (user.classes[block[1]].params && user.classes[block[1]].params.hasOwnProperty("color")) {
                    color = colors[user.classes[block[1]].params.color];
                } else {
                    color = block[3];
                }

                var classInfo;
                if (globalClasses) {
                classInfo = {
                    id: user.classes[block[1]].id.replaceAll(" ", ""),
                    name: globalClasses[user.classes[block[1]].id].name  + (isFlex ? " (Flex)" : "") ,
                    teacher: globalClasses[user.classes[block[1]].id].teacher,
                    room: globalClasses[user.classes[block[1]].id].room,
                    period: block[1],
                    color: color,
                    time: block[0],
                    isMain: false
                }
                } else {
                     classInfo = {
                        id: user.classes[block[1]].id.replaceAll(" ", ""),
                        name: user.classes[block[1]].id.split(" ").slice(0, -1).join(" ") + isFlex ? " (Flex)" : "",
                        teacher: user.classes[block[1]].params.tname,
                        room: user.classes[block[1]].params.rnumber,
                        period: block[1],
                        color: color,
                        time: block[0],
                        isMain: false
                    }
                }
                if (classInfo.name.includes("Phys Ed")) {
                    console.log("PE", block, classInfo.id)
                    if (user.hasOwnProperty("settings") && user.settings.pe) {
                    if (user.settings.wschedule) {
                        classInfo = {
                            name: block[1],
                            color: block[3],
                            time: block[0],
                            period: block[1],
                            isMain:false
                        }
                        return
                    } else {
                        return;
                    }
                    }
                    if (classInfo.id.endsWith("A")) {
                        var newEnd = new Date();
                        newEnd.setHours(classInfo.time[1].split(":")[0]);
                        newEnd.setMinutes(classInfo.time[1].split(":")[1]);
                        newEnd.setMinutes(newEnd.getMinutes() - 30)
                        classInfo.time[1] = newEnd.getHours()+":"+newEnd.getMinutes()
                        classInfo.period += " (PE A)"
                    } else {
                        var newStart = new Date();
                        newStart.setHours(classInfo.time[0].split(":")[0]);
                        newStart.setMinutes(classInfo.time[0].split(":")[1]);
                        newStart.setMinutes(newStart.getMinutes() + 30)
                        classInfo.time[0] = newStart.getHours()+":"+newStart.getMinutes()
                        classInfo.period += " (PE B)"
                    }

                }
                daySchedule.push(classInfo)
            } else if (block[2]) {
                daySchedule.push({
                    id: block[1] === "Lunch" ? "Lunch" : block[1] === "MX" ? "MX" : undefined,
                    name: block[1],
                    color: block[3],
                    time: block[0],
                    isMain: true
                })
            } else if (block.length > 4) {
                daySchedule.push({
                    name: block[4].backup[0],
                    color: block[4].backup[2],
                    time: block[0],
                    period: block[1],
                    isMain: true
                })
            } else if (user.settings.wschedule) {
               
                daySchedule.push({
                    name: block[1],
                    color: block[3],
                    time: block[0],
                    period: block[1],
                    isMain:false
                })
            }
        })
       
        return daySchedule;
    }


export {generateSchedule, timeString, colors, clubColors};